module.exports = __webpack_public_path__ + "img/potares.8f675c59.jpg";